import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';

import guestportal from './guestportal';
import acuant from './acuant';
import snackbar from './snackbar';

export default combineReducers({
    form: formReducer,
    guestportal,
    acuant,
    snackbar
});
